import React from 'react';
import { DateFormatter } from '../../../../../utils/DateFormatter';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';

const ReportHeader = (props) => {
  return (
    <div className='d-flex justify-content-between pb-0 m-0 student_response_details'>
      <div className='d-flex row'>
        <div className='d-flex'>
          {props.isLoading ?
            <Skeleton  className='w-600 mb-3 mt-2'></Skeleton>
            :
            <>
              <label>Report includes assignments assigned between: </label>
              <p className='fw-semibold ms-1'>{`${DateFormatter.toShortDate2(props.startDate)} and ${DateFormatter.toShortDate2(props.endDate)}`}</p> 
            </>
          }
        </div>
        <div className='d-flex'>
          {props.isLoading ?
            <Skeleton className='w-min-max-350 mb-3 mt-2'></Skeleton>
            :
            <>
              <label>Course: </label>
              <p className='fw-semibold ms-1'>{props.courseName}</p>
            </>
          }
        </div>
      </div>
      <div className='d-flex'>
        {props.isLoading ?
          <Skeleton className='w-min-max-350 mb-3 mt-2'></Skeleton>
          :
          <>
            <label>Report run on: </label>
            <p className='fw-semibold ms-1'>{DateFormatter.toLongDateTime2(props.reportDate)}</p>
          </>
        }
      </div>
    </div>
  );
};

ReportHeader.propTypes = {
  isLoading: PropTypes.bool,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  courseName: PropTypes.string,
  reportDate: PropTypes.string
};

export default ReportHeader;
